const childrenLoaded = require('@alexspirgel/children-loaded');

class Ticker extends HTMLDivElement {

    constructor() {
       super()
    }

    async connectedCallback() {
        try {
            // Wait for both children to load and DOM to be fully ready
            await Promise.all([
                childrenLoaded(this),
                new Promise(resolve => {
                    if (document.readyState === 'complete') {
                        resolve();
                    } else {
                        window.addEventListener('DOMContentLoaded', resolve);
                    }
                })
            ]);
            
            // Add a small delay to ensure everything is truly ready, especially for authenticated users
            setTimeout(() => {
                this.initialize();
            }, 100);
        } catch (error) {
            console.error('Error initializing ticker:', error);
        }
    }

    initialize() {
        try {
            // Make sure the element is still in the DOM
            if (document.body.contains(this)) {
                this.startTicker();
                this.initialized = true;
            }
        } catch (error) {
            console.error('Error starting ticker:', error);
        }
    }

    applyStyles = (obj, styles) => {
        Object.keys(styles).forEach(property => {
            obj.style[property] = styles[property];
        });
    };

    startTicker = () => {
        //console.log('Starting ticker')
        const tickerBox = this;
        const extendedParam = { speed: 15, delay: 1500, rotate: true };
        this.applyStyles(tickerBox, { overflow: "hidden", 'min-height': '40px' });

        // Add defensive checks to make sure elements exist before accessing them
        const ul = tickerBox.getElementsByTagName("ul");
        if (!ul || ul.length === 0) {
            console.warn('Ticker container has no UL elements');
            return;
        }
        
        const li = ul[0].getElementsByTagName("li");
        if (!li || li.length === 0) {
            console.warn('Ticker UL has no LI elements');
            return;
        }
        
        this.applyStyles(ul[0], { padding: 0, margin: 0, position: 'relative', 'list-style-type': 'none' });

        for (let i = 0; i < li.length; i++) {
            this.applyStyles(li[i], { position: 'absolute', 'white-space': 'nowrap', display: 'none' });
        }

        let li_index = 0;
        let trans_width = 100;//tickerBox.offsetWidth;
        const chunk_width = 1;

        const iterateTickerElement = (trans_width) => {
            // Verify ticker still exists in DOM before proceeding
            if (!document.body.contains(tickerBox) || !document.body.contains(li[li_index])) {
                console.warn('Ticker element removed from DOM, stopping animation');
                return;
            }
            
            li[li_index].style.left = trans_width + "px";
            li[li_index].style.display = '';
            const t = setInterval(() => {
                // Check if element still exists before manipulating
                if (!document.body.contains(tickerBox) || !document.body.contains(li[li_index])) {
                    clearInterval(t);
                    return;
                }
                
                if (parseInt(li[li_index].style.left) > -li[li_index].offsetWidth) {
                    li[li_index].style.left = parseInt(li[li_index].style.left) - chunk_width + "px";
                } else {
                    clearInterval(t);
                    trans_width = tickerBox.offsetWidth;
                    li_index++;
                    if (li_index === li.length && extendedParam.rotate) {
                        li_index = 0;
                        iterateTickerElement(trans_width);
                    } else if (li_index < li.length) {
                        setTimeout(() => { iterateTickerElement(trans_width); }, extendedParam.delay);
                    }
                }
            }, extendedParam.speed);

            tickerBox.onmouseover = () => {
                // clearInterval(t);
            };

            tickerBox.onmouseout = () => {
                // iterateTickerElement(parseInt(li[li_index].style.left));
            };
        };

        iterateTickerElement(trans_width);
    };
}

customElements.define('block-ticker', Ticker, {extends: 'div'});